module.exports = " <section id=speaker _v-59f38ab8=\"\"> <div class=row _v-59f38ab8=\"\"> <div class=columns _v-59f38ab8=\"\"> <h4 _v-59f38ab8=\"\">{{ conf.menu.speaker }}</h4> <div class=\"speaker-wrapper align-center\" _v-59f38ab8=\"\"> <div class=row v-for=\"speakers in conf.speakers\" _v-59f38ab8=\"\"> <avatar v-for=\"detail in speakers\" :detail=detail _v-59f38ab8=\"\"></avatar> </div> </div> </div> </div> </section> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-59f38ab8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Speaker.vue
 ** module id = 63
 ** module chunks = 1
 **/